export const activityTypeVariantData = [
  {
    displayName: 'Curtain Call',
    component: 'CurtainCall',
    variant: 'CurtainCall'
  },
  {
    displayName: 'Shuffled Letters',
    component: 'ObjectShuffle',
    variant: 'ObjectShuffle'
  },
  {
    displayName: 'Write My Name',
    component: 'WriteMyName',
    variant: 'WriteMyName'
  },
  {
    displayName: 'Mat Man Match',
    component: 'MatManMatch',
    variant: 'MatManMatch'
  },
  {
    displayName: 'Type To See',
    component: 'TypeToSee',
    variant: 'TopBottomPanelReveal'
  },
  {
    displayName: 'Sounds the Same',
    component: 'SoundsTheSame',
    variant: 'Homonym'
  },
  {
    displayName: 'Letters with Wood Pieces',
    component: 'LettersWithWoodPieces',
    variant: 'WoodPieces'
  },
  {
    displayName: 'Puzzle Pieces',
    component: 'PuzzlePieces',
    variant: 'PuzzlePieces'
  },
  {
    displayName: 'Slide It Over',
    component: 'SlideItOver',
    variant: 'LeftRightPanelReveal'
  },
  {
    displayName: 'Write About It',
    component: 'WriteAboutIt',
    variant: 'LeftImageParagraph'
  },
  {
    displayName: 'One and More',
    component: 'OneAndMore',
    variant: 'OneAndMore'
  },
  {
    displayName: 'On the Stage',
    component: 'OnTheStage',
    variant: 'MusiciansOnStage'
  },
  {
    displayName: 'Not the Same',
    component: 'NotTheSame',
    variant: 'NotTheSame'
  },
  {
    displayName: 'Making Space',
    component: 'MakingSpace',
    variant: 'Spacebar'
  },
  {
    displayName: 'Starts With',
    component: 'StartsWith',
    variant: 'StartsWith'
  },
  {
    displayName: 'Rhymes With',
    component: 'RhymesWith',
    variant: 'RhymesWith'
  },
  {
    displayName: 'Math Sentences',
    component: 'MathSentences',
    variant: 'MathSentences'
  },
  {
    displayName: 'Stop, Drop and Type',
    component: 'StopDropAndType',
    variant: 'StopDropAndType'
  },
  {
    displayName: 'Zoom In, Zoom Out',
    component: 'ZoomInZoomOut',
    variant: 'BeginningLetter'
  },
  {
    displayName: 'The Label Maker',
    component: 'TheLabelMaker',
    variant: 'LabelMaker'
  },
  {
    displayName: "Mrs. New's Syllables",
    component: 'MrsNewsSyllables',
    variant: 'MrsNewsSyllables'
  },
  {
    displayName: 'Fancy Formatting',
    component: 'FancyFormatting',
    variant: 'FancyFormatting'
  },
  {
    displayName: 'Math Masters',
    component: 'MathMaster',
    variant: 'MathMaster'
  },
  {
    displayName: 'Build a Keyboard',
    component: 'BuildAKeyboard',
    variant: 'BuildAKeyboard'
  },
  {
    displayName: 'Line By Line',
    component: 'LineByLine',
    variant: 'LeftImageSentences'
  },
  {
    displayName: 'Words',
    component: 'Words',
    variant: 'AWordsWPM'
  },
  {
    displayName: 'Letters',
    component: 'Letters',
    variant: 'ALettersKPM'
  },
  {
    displayName: 'Sentences',
    component: 'Sentences',
    variant: 'ASentencesWPM'
  },
  {
    displayName: 'Paragraph',
    component: 'Paragraph',
    variant: 'AParagraphWPM'
  },
  {
    displayName: 'Concentration',
    component: 'Concentration',
    variant: 'Concentration'
  },
  {
    displayName: 'Dolch Dynamite',
    component: 'DolchDynamite',
    variant: 'DolchDynamite'
  },
  {
    displayName: 'Dolch & Space',
    component: 'DolchAndSpace',
    variant: 'DolchSpace'
  },
  {
    displayName: 'Face Flip',
    component: 'FaceFlip',
    variant: 'FaceFlip'
  },
  {
    displayName: 'Fill in the Blanks',
    component: 'FillInTheBlanks',
    variant: 'FillInTheBlanks'
  },
  {
    displayName: 'Dump the Combo',
    component: 'DumpTheCombo',
    variant: 'DumpTheCombo'
  },
  {
    displayName: 'Bits About It',
    component: 'BitsAboutIt',
    variant: 'FillBlankSentences'
  },
  {
    displayName: 'Find the Letter',
    component: 'FindTheLetter',
    variant: 'FindTheLetter'
  },
  {
    displayName: 'Shift for Capitals',
    component: 'ShiftForCapitals',
    variant: 'ShiftForCapitals'
  },
  {
    displayName: 'Questions and Answers',
    component: 'QuestionsAndAnswers',
    variant: 'QandA'
  },
  {
    displayName: 'Pick Me!',
    component: 'PickMe',
    variant: 'ObjectInASentence'
  },
  {
    displayName: 'Painted Finger Clues',
    component: 'PaintedFingerClue',
    variant: 'PaintedFingerClue'
  },
  {
    displayName: 'Center of Attention',
    component: 'CenterOfAttention',
    variant: 'ParagraphCentered'
  },
  {
    displayName: 'Puzzle Surprise',
    component: 'PuzzleSurprise',
    variant: 'PuzzlingLetters'
  },
  {
    displayName: "What's It Mean?",
    component: 'WhatsItMean',
    variant: 'QuoteBubble'
  },
  {
    displayName: 'Tell Me More',
    component: 'TellMeMore',
    variant: 'QuoteBubble2'
  },
  {
    displayName: 'Rhyme Card',
    component: 'RhymeCard',
    variant: 'RhymeFlip'
  },
  {
    displayName: 'Scrolled Secrets',
    component: 'ScrolledSecrets',
    variant: 'ScrolledSecrets'
  },
  {
    displayName: 'Sentence Doctor',
    component: 'SentenceDoctor',
    variant: 'SentenceDoctor'
  },
  {
    displayName: 'Shifty Targets',
    component: 'ShiftyTargets',
    variant: 'ShiftyTargets'
  },
  {
    displayName: 'Target Practice',
    component: 'TargetPractice',
    variant: 'TargetPractice'
  },
  {
    displayName: 'Venn Diagram',
    component: 'VennDiagram',
    variant: 'VennDiagram'
  },
  {
    displayName: 'Bouncing Vowels',
    component: 'BouncingVowels',
    variant: 'VowelComboLaunch'
  },
  {
    displayName: 'Syllable Pop-Up',
    component: 'SyllablePopUp',
    variant: 'WhackAMole'
  },
  {
    displayName: 'Build a Sentence',
    component: 'BuildASentence',
    variant: 'BuildASentence'
  },
  {
    displayName: "Tab, You're It!",
    component: 'TabYoureIt',
    variant: 'TabYoureIt'
  },
  {
    displayName: 'Teacher Creation',
    component: 'TeacherCreation',
    variant: 'TeacherCreation'
  },
  {
    displayName: 'Hear It, Type It',
    component: 'HearItTypeIt',
    variant: 'HearItTypeIt'
  },
  {
    displayName: 'My Choice Keyboarding',
    component: 'MyChoiceKeyboarding',
    variant: 'MyChoiceKeyboarding'
  },
  {
    displayName: 'Equation Builder',
    component: 'EquationBuilder',
    variant: 'equation-builder'
  },
  {
    displayName: 'Multi Select',
    component: 'MultiSelect',
    variant: 'multi-select'
  },
  {
    displayName: 'Highlight It',
    component: 'HighlightIt',
    variant: 'highlight-it'
  },
  {
    displayName: 'Select It',
    component: 'SelectIt',
    variant: 'select-it',
    hasCustomNextButton: true
  },
  {
    displayName: 'Drag and Drop - Build Fractions',
    component: 'DragAndDropBuildFractions',
    variant: 'drag-and-drop-build-fractions'
  },
  {
    displayName: 'Drag and Drop - Comparison',
    component: 'DragAndDropComparison',
    variant: 'drag-and-drop-comparison'
  },
  {
    displayName: 'Drag and Drop - Categories',
    component: 'DragAndDropCategories',
    variant: 'drag-and-drop-categories'
  },
  {
    displayName: 'Drag and Drop - Table',
    component: 'DragAndDropTable',
    variant: 'drag-and-drop-table'
  },
  {
    displayName: 'Graph It - Table',
    component: 'GraphIt',
    variant: 'graph-it-table'
  },
  {
    displayName: 'Graph It - Image',
    component: 'HighlightIt',
    variant: 'graph-it-image'
  },
  {
    displayName: 'Pick the Answer',
    component: 'PickTheAnswer',
    variant: 'pick-the-answer'
  },
  {
    displayName: 'Construct a Response',
    component: 'ConstructAResponse',
    variant: 'construct-a-response'
  },
  {
    displayName: 'Multi-Part',
    component: 'MultiPart',
    variant: 'multi-part'
  }
];
